import Chart from 'react-apexcharts';

const CircleCircuit = ({ statistics }) => {
  let labels = [];
  let series = [];
  statistics?.medsRating?.forEach((element) => {
    labels.push(element.rate);
    series.push(element.percentage);
  });
  const chartOptions = {
    chart: {
      type: 'donut',
    },
    lebels: labels,
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
  };

  const chartSeries = series;

  return (
    <div className="flex justify-center">
      <Chart
        options={chartOptions}
        series={chartSeries}
        type="donut"
        width="100%"
        height="500px"
      />
    </div>
  );
};

export default CircleCircuit;
